import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {parseISOString } from "../functions/Functions"; 

const VideoStreamComponent = (props) => {

    return (    
      <div className="col-lg-6 col-sm-12">
        {/* <iframe src={"https://www.facebook.com/plugins/video.php?height=314&href=https://www.facebook.com/"+ props.permalinkUrl +"/&show_text=false&width=560&t=0"} width={560} height={314} style={{
            border: "none",
            overflow: "hidden",
            height: "220",
            overflow: "visible",
          }} scrolling="no" frameBorder="0"  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>  */}

<div style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; height: auto;">
  <iframe src={"https://www.facebook.com/plugins/video.php?height=314&href=https://www.facebook.com/" + props.permalinkUrl + "/&show_text=false&width=560&t=0"} 
    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; overflow: hidden;" 
    scrolling="no" frameborder="0" 
    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" 
    allowfullscreen="true">
  </iframe>
</div>

      <div className="event_post">
          <ul className="list_style sermons_category event_category">
          <li>
              <i className="lnr lnr-tag"></i>
              {props.title}
            </li> 
            <li>
              <i className="lnr lnr-calendar-full"></i>
              { parseISOString(props.creation_time).toString()}
             
            </li>
          </ul>
        </div>
    </div> );
}

export default VideoStreamComponent;